const BASE_API = '/power-cable-auth'
export {BASE_API}